export const DELETE_PRODUCT_MUTATION = gql`
    mutation deleteProduct($id: Int!) {
        deleteProduct(id: $id) {
            id
            name
        }
    }
`;

export const CREATE_PRODUCT_MUTATION = gql`
    mutation createProduct($input: CreateProductInput!) {
        createProduct(input: $input) {
            id
            name
        }
    }
`;

export const UPDATE_PRODUCT_MUTATION = gql`
    mutation updateProduct($id: Int!, $input: UpdateProductInput!) {
        updateProduct(id: $id, input: $input) {
            id
            name
        }
    }
`;
